import React from 'react';
import { Terminal, Github, Twitter, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-cyber-black border-t border-cyber-purple/20 pt-16 pb-8 relative overflow-hidden" data-id="element-31">
      {/* Grid Background Bottom */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-cyber-purple/5 to-transparent pointer-events-none" data-id="element-32" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-33">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-34">
          <div className="col-span-1 md:col-span-2" data-id="element-35">
            <div className="flex items-center gap-2 mb-6" data-id="element-36">
              <Terminal className="h-6 w-6 text-cyber-cyan" data-id="element-37" />
              <span className="font-orbitron text-xl font-bold text-white tracking-wider" data-id="element-38">
                ALPHAGAMER
              </span>
            </div>
            <p className="text-gray-400 font-rajdhani max-w-md mb-6" data-id="element-39">
              The ultimate destination for digital warriors. High-end rigs,
              competitive atmosphere, and a community that never sleeps.
            </p>
            <div className="flex space-x-4" data-id="element-40">
              <a href="#" className="text-gray-500 hover:text-cyber-cyan transition-colors" data-id="element-41">
                <Twitter className="w-5 h-5" data-id="element-42" />
              </a>
              <a href="#" className="text-gray-500 hover:text-cyber-purple transition-colors" data-id="element-43">
                <Instagram className="w-5 h-5" data-id="element-44" />
              </a>
              <a href="#" className="text-gray-500 hover:text-cyber-green transition-colors" data-id="element-45">
                <Github className="w-5 h-5" data-id="element-46" />
              </a>
            </div>
          </div>

          <div data-id="element-47">
            <h4 className="font-orbitron text-white mb-6" data-id="element-48">SECTORS</h4>
            <ul className="space-y-3 font-rajdhani text-gray-400" data-id="element-49">
              <li data-id="element-50">
                <a href="#services" className="hover:text-cyber-cyan transition-colors" data-id="element-51">
                  Services
                </a>
              </li>
              <li data-id="element-52">
                <a href="#about" className="hover:text-cyber-cyan transition-colors" data-id="element-53">
                  About
                </a>
              </li>
              <li data-id="element-54">
                <a href="#location" className="hover:text-cyber-cyan transition-colors" data-id="element-55">
                  Location
                </a>
              </li>
              <li data-id="element-56">
                <a href="#" className="hover:text-cyber-cyan transition-colors" data-id="element-57">
                  Membership
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-58">
            <h4 className="font-orbitron text-white mb-6" data-id="element-59">LEGAL</h4>
            <ul className="space-y-3 font-rajdhani text-gray-400" data-id="element-60">
              <li data-id="element-61">
                <a href="#" className="hover:text-cyber-pink transition-colors" data-id="element-62">
                  Privacy Protocol
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-cyber-pink transition-colors" data-id="element-64">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-65">
                <a href="#" className="hover:text-cyber-pink transition-colors" data-id="element-66">
                  Code of Conduct
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-67">
          <p className="text-gray-500 font-rajdhani text-sm" data-id="element-68">
            © 2026 Alphagamer. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-xs text-gray-600 font-mono uppercase" data-id="element-69">
            <span className="w-2 h-2 bg-cyber-green rounded-full animate-pulse" data-id="element-70" />
            System Operational
          </div>
        </div>
      </div>
    </footer>;
}